export default __webpack_public_path__ + "static/media/pass.733ab324.svg";